import { render, staticRenderFns } from "./MoleculeFloorOrientationBarV2.vue?vue&type=template&id=39222a01&"
import script from "./MoleculeFloorOrientationBarV2.vue?vue&type=script&lang=js&"
export * from "./MoleculeFloorOrientationBarV2.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeFloorOrientationBarV2.vue?vue&type=style&index=0&id=39222a01&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeBuildingOrientationBar.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FbuildingV2%2FMoleculeFloorOrientationBarV2.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomInfoPopup: require('/app/components/atoms/common/AtomInfoPopup.vue').default,AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,MoleculesProjectMoleculeFitoutSelector: require('/app/components/molecules/project/MoleculeFitoutSelector.vue').default,AtomsCommonAtomInfoPrice: require('/app/components/atoms/common/AtomInfoPrice.vue').default})
